import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src", "height"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      src: _ctx.source,
      alt: "Logo da GreeZon",
      height: _ctx.height,
      id: "greezon_logo"
    }, null, 8, _hoisted_1)
  ]))
}